import { getModel } from '../../model/registry'
import { useEffect, useLayoutEffect } from "react"

//Form State
import { useMessage } from "../pageView/Page"
import useFormModal from "../modal/useModalDialog"

import CardViewTitle from "../cardView/CardViewTitle"
import DisplayViewDocument from "./DisplayViewDocument"
import useFormActions from "../cardView/useFormActions"

import MessageBar from "../toast/MessageBar"
import { PopUp } from "../modal/PopUp"
import MobilePanel from "../mobilePanel/MobilePanel"

import styled from "styled-components"
import useFormValidation from "../cardView/useFormValidation"
import { useStore } from "../pageView/Page"
import { useModalStack } from "../../context/modalStackContext"
import NotificationBar from "./NotificationBar"

const DisplayViewWrapper = styled.div`
    max-width: ${(props) => props.width};
    margin-bottom: 1rem;
`

const DisplayView = ({ type, options }) => {
    const [, setState, getState] = useStore(s => null)
    const { pushModal } = useModalStack()

    //State used to manage the MessageBar at the Top of the Form
    //const { message, setMessage } = useFormMessage()
    const [message, setMessage] = useMessage((s) => s)

    //Managing the Confirmation Dialog
    const { showModal, setShowModal, modalConfig } = useFormModal()

    //Config to read the data from the Model
    const config = getModel('displayViewData')[type]

    const { handleFormChange, handleActions } = useFormActions('edit', config)
    //const { validated } = useFormValidation()
    const { validated } = useFormValidation(config.entity)

    //Setting the savedOn date tells the PDF to load the file
    useLayoutEffect(() => {
        const savedOn = new Date()
        setState({savedOn})
    }, [setState])

    useEffect(() => {
        if (showModal === true) {
            pushModal(PopUp, { config: modalConfig, setShow: setShowModal, setAction: handleActions, data: getState() })
            setShowModal(false)
        }
    }, [showModal, pushModal, modalConfig, setShowModal, handleActions, getState])

    return (
        <>
            <DisplayViewWrapper name='DisplayView' width={config.width}>
                {message.show && <MessageBar title={message.title} message={message.message} type={message.type} setMessage={setMessage} action={message.action || undefined} handleAction={handleFormChange} />}

                <CardViewTitle config={config} options={options}
                    handleActions={handleActions}
                />
                <NotificationBar notifications={config.notifications} />
                <br></br>
                <DisplayViewDocument config={config}></DisplayViewDocument>
                {/* <PopUp show={showModal} setShow={setShowModal} config={modalConfig} setAction={handleActions} data={state} /> */}
            </DisplayViewWrapper>
            {
                config.mobilePanel && <MobilePanel validated={validated}
                    config={config.mobilePanel} useStore={useStore}></MobilePanel>
            }
        </>
    )
}

export default DisplayView